export default "__VITE_ASSET__Bbih9FWW__"